<template>
  <app-base-main>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-radio-group
            v-model="claimStatus"
            :options="[
              {id: 0, text: '未索赔'},
              {id: 1, text: '已索赔'},
            ]"
            @input="changeStatus"
        ></gj-radio-group>
        <gj-country-server-select
            v-model="countryAndMarket"
        ></gj-country-server-select>
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 'msku', text: 'MSKU'},
              {id: 'fnsku', text: 'FNSKU'},
            ]"
        ></gj-select-input>
        <template #right>
          <gj-tool-group
              help
              :download="$permission('claim:export')"
              @clickDownload="download"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :default-sort="{prop: 'quantity', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
      >
        <template v-slot:estimateDamageQuantity="{ row }">
          {{row.estimateDamageQuantity}}
          <gj-popover-panel
              :title="'库存损坏赔偿详情'"
              :width="'180px'"
              :data="[
                {label: '应赔偿数量', value: row.shouldDamageQuantity},
                {label: '已赔偿数量', value: row.claimedDamageQuantity},
                {label: '预计赔偿数量', value: row.estimateDamageQuantity},
              ]"
          ></gj-popover-panel>
        </template>
        <template v-slot:estimateLostQuantity="{ row }">
          {{row.estimateLostQuantity}}
          <gj-popover-panel
              :title="'库存丢失赔偿详情'"
              :width="'180px'"
              :data="[
                {label: '应赔偿数量', value: row.shouldLostQuantity},
                {label: '已赔偿数量', value: row.claimedLostQuantity},
                {label: '预计赔偿数量', value: row.estimateLostQuantity},
              ]"
          ></gj-popover-panel>
        </template>
        <template v-slot:memo="{ row }">
          <template v-if="$permission('claim:edit')">
            <gj-edit-input
                :value="row.memo"
                :item="row"
                table-cell-edit
                :on-confirm="onConfirm"
                :pop-title="'编辑备注'"
            ></gj-edit-input>
          </template>
          <template v-else>
            {{row.memo}}
          </template>

        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
            <template v-if="claimStatus === 0">
              <template v-if="$permission('claim:edit')">
                <gj-button type="text" @click="inputCase(row)">填写CaseID</gj-button>
              </template>
            </template>
            <template v-else>
              <gj-button type="text" @click="inputCase(row, 1)">查看CaseID</gj-button>
            </template>
            <template #dropdown v-if="$permission('claim:edit')">
              <gj-dropdown-item @click="viewTemplate(row)">查看Case模板</gj-dropdown-item>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import ClaimInputCase from './components/inventory-claim/madal/claim-input-case';
  import ClaimCaseTemplate from './components/inventory-claim/madal/claim-case-template';
  import {isMeaningful} from "@/utils/common";
  import {exportClaimDetail, getClaimDetailPage, updateClaimMemo,lookTemplate} from "@/api/sale";

  export default {
    name: "claim-detail",
    mixins: [queryMixin],
    watch: {
      $route: {
        immediate: true,
        handler(router) {
          this.columns = this._.cloneDeep(this.notClaimCol);
          if (router && router.query.link === 'opDetail' && router.query.timestamp !== this.timestamp) {
            this.isInitParams = false;
            this.keyword.key = 'msku';
            this.keyword.value = null;
            this.countryAndMarket = {
              countryIds: [router.query.countryCode],
              marketIds: [router.query.marketId],
            };
            this.claimStatus = 0;
            this.timestamp = router.query.timestamp;
            this.$gjResetPage();
          }
        },
      },
    },
    data() {
      return {
        timestamp: null,
        tableData: [],
        columns: [],
        notClaimCol: [
          {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '140px'},
          {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '160px'},
          {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '120px'},
          {id: 'estimateDamageQuantity', header: '库存损坏赔偿', field: 'slot:estimateDamageQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateLostQuantity', header: '库存丢失赔偿', field: 'slot:estimateLostQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateClaimQuantity', header: '预计索赔数量', field: 'estimateClaimQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateClaimCost', header: '预计索赔金额', field: 'estimateClaimCost', minWidth: '120px', align: 'right', sortable: true, prefix: 'estimateClaimCurrencySymbol'},
          {id: 'reportStartTime', header: '报表开始时间', field: 'reportStartTime', minWidth: '140px', sortable: true,},
          {id: 'reportEndTime', header: '报表结束时间', field: 'reportEndTime', minWidth: '140px', sortable: true,},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '140px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '140px', fixed: 'right', notCustomColumn: true},
        ],
        claimCol: [
          {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '140px'},
          {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '160px'},
          {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '120px'},
          {id: 'estimateDamageQuantity', header: '库存损坏赔偿', field: 'slot:estimateDamageQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateLostQuantity', header: '库存丢失赔偿', field: 'slot:estimateLostQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateClaimQuantity', header: '预计索赔数量', field: 'estimateClaimQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'estimateClaimCost', header: '预计索赔金额', field: 'estimateClaimCost', minWidth: '120px', align: 'right', sortable: true, prefix: 'estimateClaimCurrencySymbol'},
          {id: 'realClaimQuantity', header: '实际索赔数量', field: 'realClaimQuantity', minWidth: '120px', align: 'right', sortable: true,},
          {id: 'realClaimCost', header: '实际索赔金额', field: 'realClaimCost', minWidth: '120px', align: 'right', sortable: true, prefix: 'estimateClaimCurrencySymbol'},
          {id: 'statusName', header: '索赔结果', field: 'statusName', minWidth: '120px'},
          {id: 'reportStartTime', header: '报表开始时间', field: 'reportStartTime', minWidth: '140px', sortable: true,},
          {id: 'reportEndTime', header: '报表结束时间', field: 'reportEndTime', minWidth: '140px', sortable: true,},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '140px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '140px', fixed: 'right', notCustomColumn: true},
        ],
        claimStatus: 0,
        countryAndMarket: null,
        keyword: {
          key: 'msku',
          value: null,
        }
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        this.globalParams = {
          model: {
            marketIds: isMeaningful(this.countryAndMarket) ? this.countryAndMarket.marketIds : null,
            countrys: isMeaningful(this.countryAndMarket) ? this.countryAndMarket.countryIds : null,
            statusList: this.claimStatus === 0 ? ['non'] : ['claiming', 'success', 'fail']
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        this.globalParams.model[this.keyword.key] = this.keyword.value;
        getClaimDetailPage(this.globalParams)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          countryAndMarket: null,
          keyword: {
            key: 'msku',
            value: null,
          },
          claimStatus: 0,
        }
      },
      download() {
        exportClaimDetail(this.globalParams)
      },
      changeStatus() {
        if (this.claimStatus === 0) {
          this.columns = this.notClaimCol;
        } else {
          this.columns = this.claimCol;
        }
        this.$gjNoticeQuery();
      },
      onConfirm(memo, data, closeEditor) {
        updateClaimMemo({id: data.id, memo: memo})
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
            closeEditor();
          })
      },
      inputCase(row, state = 0) {
        const modal = this.$gjCreate(ClaimInputCase, {
          props: {
            id: row.id,
            msku: row.msku,
            item: state === 0 ? null: row,
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      viewTemplate(row) {
        const params={
          beginDate:row.reportStartTime,
          endDate:row.reportEndTime,
          estimateClaimQuantity:row.estimateClaimQuantity,
          fnsku:row.fnsku,
          marketId:row.marketId,
          msku:row.msku,
        }
        lookTemplate(params).then((data)=>{
          this.$gjCreate(ClaimCaseTemplate, {
          props: {
            item: row,
            propductInfo:data
          }
        })
        })
        
      }
    }
  }
</script>

<style scoped>

</style>
